<!-- 会员储值弹窗组件 -->
<template>
  <el-dialog 
    title="会员储值" 
    :visible.sync="dialogVisible" 
    width="400px" 
    append-to-body
    @opened="onDialogOpened" 
    @close="onDialogClose"
  >
    <el-form 
      id="rechargeForm" 
      ref="rechargeForm" 
      :model="formData" 
      :rules="rechargeRules" 
      label-width="100px"
      size="small" 
      @submit.native.prevent
    >
      <el-form-item label="会员卡号">
        <span>{{ formData.cardNo || '未选择会员' }}</span>
      </el-form-item>
      <el-form-item label="会员姓名">
        <span>{{ formData.name || '未选择会员' }}</span>
      </el-form-item>
      <el-form-item label="当前余额">
        <span>¥{{ formData.storedBalance || 0 }}</span>
      </el-form-item>
      <el-form-item label="充值金额" prop="psmoney">
        <el-input 
          ref="rechargeInput" 
          v-model.number="formData.psmoney" 
          type="number" 
          placeholder="请输入充值金额"
          @keydown.enter.native.prevent="confirmRecharge" 
        />
      </el-form-item>
      <el-form-item label="备注">
        <el-input 
        style="margin-top: 20px;"
          ref="remarkInput" 
          v-model="formData.remark" 
          type="textarea"
          rows="2" 
          placeholder="请输入备注"
          @keydown.enter.native.prevent="confirmRecharge" 
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="confirmRecharge">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'MemberRechargeDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    memberInfo: {
      type: Object,
      default: () => ({
        cardNo: '',
        name: '',
        storedBalance: '',
        memId: '',
        psmoney: ''
      })
    }
  },
  data() {
    return {
      formData: {
        cardNo: '',
        name: '',
        storedBalance: '',
        memId: '',
        psmoney: '',
        remark:"",
      },
      rechargeRules: {
        psmoney: [
          { required: true, message: '请输入充值金额', trigger: 'blur' },
          { type: 'number', message: '充值金额必须为数字', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value <= 0) {
                callback(new Error('充值金额必须大于0'))
              } else {
                callback()
              }
            }, 
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    memberInfo: {
      handler(newVal) {
        if (newVal) {
          this.formData = { ...newVal }
        }
      },
      deep: true,
      immediate: true
    },
    visible(newVal) {
      if (newVal) {
        // 重置充值金额
        this.formData.psmoney = ''
      }
    }
  },
  methods: {
    // 弹窗打开事件
    onDialogOpened() {
      // 重置充值金额
      this.formData.psmoney = ''

      // 触发打开事件，让父组件处理账簿列表重新加载等逻辑
      this.$emit('opened')

      // 自动聚焦到充值金额输入框
      this.$nextTick(() => {
        if (this.$refs.rechargeInput) {
          this.$refs.rechargeInput.focus()
          this.$refs.rechargeInput.select()
        }
      })
    },

    // 弹窗关闭事件
    onDialogClose() {
      // 重置表单
      if (this.$refs.rechargeForm) {
        this.$refs.rechargeForm.resetFields()
      }
      this.$emit('cancel') 
    },

    // 确认储值
    confirmRecharge() {
      this.$refs.rechargeForm.validate((valid) => {
        if (valid) {
          const rechargeData = {
            ...this.formData,
            psmoney: parseFloat(this.formData.psmoney) || 0
          }
          this.$emit('confirm', rechargeData)
        } 
      })
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
::v-deep #rechargeForm .el-form-item__label {
  color: #606266 !important;
}

.el-form-item span {
  color: #606266;
  font-weight: normal;
}

/* 会员信息显示样式 */
.el-form-item span {
  font-size: 14px;
}
</style>
